import { useState } from 'react';
import { record } from '@solimat/solimat-web-endpoint';

const useCreateSolicitudCATAFuego = () => {
    const [loadingCreateSolicitudCATAFuego, setLoadingCreateSolicitudCATAFuego] = useState(false);
    const [successCreateSolicitudCATAFuego, setSuccessCreateSolicitudCATAFuego] = useState(false);
    const [errorCreateSolicitudCATAFuego, setErrorCreateSolicitudCATAFuego] = useState(null);
    const [dataCreateSolicitudCATAFuego, setDataCreateSolicitudCATAFuego] = useState(null);

    const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || '';
    const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || '';
    const apiRecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

    const createSolicitudCATAFuego = async (userId: string, data: any, callback?: (data: any) => void) => {
        setLoadingCreateSolicitudCATAFuego(true);
        setSuccessCreateSolicitudCATAFuego(false);
        setErrorCreateSolicitudCATAFuego(null);

        try {
            const response = await apiRecord.newSolicitudCataFmIncendio(userId, data);
            setSuccessCreateSolicitudCATAFuego(true);
            setDataCreateSolicitudCATAFuego(response.data);
            callback?.(response.data);
            return response.data;
        } catch (error: any) {
            const responseData = error?.response?.data;
            setErrorCreateSolicitudCATAFuego(responseData || error?.message || 'Error');
            throw error;
        } finally {
            setLoadingCreateSolicitudCATAFuego(false);
        }
    };

    return {
        createSolicitudCATAFuego,
        loadingCreateSolicitudCATAFuego,
        successCreateSolicitudCATAFuego,
        errorCreateSolicitudCATAFuego,
        dataCreateSolicitudCATAFuego,
    };
};

export default useCreateSolicitudCATAFuego;